import React from 'react';
import { FormControl, FormLabel, Input } from '@chakra-ui/react';
import TextError from '../common/TextError';
import Required from '../common/Required';

export default function CustomInput(props) {
    const { formik, label, name, id, required, type="text", ...rest } = props;

    return (
        <FormControl id={id}>
            <FormLabel>
                {label}
                {required ? <Required /> : ''}
            </FormLabel>
            <Input 
                type={type}
                name={name}
                onChange={formik.handleChange} 
                onBlur={formik.handleBlur} 
                value={formik.values[name]} 
                {...rest}
            />
            {formik.touched[name] && formik.errors[name] &&
                <TextError val={formik.errors[name]} />
            }
        </FormControl>
    )
}